import { i18n } from "./../../../plugins/vue-i18n";

const validateITN = {
  validate: validate,
  message: i18n.t("VALIDATION_ERRORS.validateITN"),
};

function validate(input) {
  let isNumbers = /^\d+$/.test(input);
  let isCorrectCheckDigits = validateCheckDigits(input);
  let isCorrectRegionNumber = input[0] != "0" || input[1] != "0";

  return isNumbers && isCorrectCheckDigits && isCorrectRegionNumber;
}

function validateCheckDigits(itnDigits) {
  if (itnDigits.length == 10) {
    let checkDigit_10 = ((2 * itnDigits[0] + 4 * itnDigits[1] + 10 * itnDigits[2] + 3 * itnDigits[3] + 5 * itnDigits[4] + 9 * itnDigits[5] + 4 * itnDigits[6] + 6 * itnDigits[7] + 8 * itnDigits[8]) % 11) % 10;
    return checkDigit_10 == itnDigits[9];
  } else if (itnDigits.length == 12){
    let checkDigit_11 = ((7 * itnDigits[0] + 2 * itnDigits[1] + 4 * itnDigits[2] + 10 * itnDigits[3] + 3 * itnDigits[4] + 5 * itnDigits[5] + 9 * itnDigits[6] + 4 * itnDigits[7] + 6 * itnDigits[8] + 8 * itnDigits[9]) % 11) % 10;
    let checkDigit_12 = ((3 * itnDigits[0] + 7 * itnDigits[1] + 2 * itnDigits[2] + 4 * itnDigits[3] + 10 * itnDigits[4] + 3 * itnDigits[5] + 5 * itnDigits[6] + 9 * itnDigits[7] + 4 * itnDigits[8] + 6 * itnDigits[9] + 8 * itnDigits[10]) % 11) % 10;
    return checkDigit_11 == itnDigits[10] && checkDigit_12 == itnDigits[11]
  } else {
    return false;
  }
}

export default validateITN;
